import { useLocalization } from '@ais-ui/locale-management';
import { MultiFactor } from './MultiFactor';

export function SettingsTwoFactorAuthPage() {
  const { messages } = useLocalization();

  return (
    <div className="space-y-6 w-full">
      <MultiFactor />
    </div>
  );
}
